import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import cn from "classnames";
import styles from "./Footer.module.sass";
import Subscription from "../Subscription";
import Theme from "../Theme";
import Icon from "../Icon";
import Image from "../Image";

const menu = [
    {
        title: "Accueil",
        url: "/",
    },
    {
        title: "Forfaits",
        url: "/forfaits",
    },
    {
        title: "CGU",
        url: "/CGU",
    },
    {
        title: "Confidentialite",
        url: "/Confidentialite",
    },
    {
        title: "Connexion",
        url: "https://app.edutio.fr",
    },
];

const socials = [
    {
        title: "facebook",
        size: "16",
        url: "https://www.facebook.com/people/Edutio/61580746033726/",
    },
    {
        title: "linkedin",
        size: "18",
        url: "https://www.linkedin.com/company/edutio/",
    },
    {
        title: "instagram",
        size: "16",
        url: "https://www.facebook.com/ui8.net",
    },
];

const Footer = () => {
    const [visible, setVisible] = useState(false);

    const { pathname } = useLocation();

    return (
        <footer className={styles.footer}>
            <div className={styles.body}>
                <div className={cn("container", styles.container)}>
                    <div className={styles.col}>
                        <div className={styles.box}>
                            <Link className={styles.logo} to="/">
                                <Image
                                    className={styles.pic}
                                    src="/images/logo-footer.svg"
                                    srcDark="/images/logo-footer.svg"
                                    alt="Logo Edutio"
                                />
                            </Link>
                            <Theme className={styles.theme} />
                        </div>
                        <div
                            className={cn(styles.item, {
                                [styles.active]: visible,
                            })}
                        >
                            <div
                                className={styles.category}
                                onClick={() => setVisible(!visible)}
                            >
                                Informations
                                <Icon name="arrow-bottom" size="9" />
                            </div>
                            <div className={styles.menu}>
                                {menu.map((x, index) => (
                                    <NavLink
                                        className={cn(styles.link, {
                                            [styles.active]: pathname === x.url,
                                        })}
                                        to={x.url}
                                        key={index}
                                    >
                                        {x.title}
                                    </NavLink>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className={styles.col}>
                        <div className={styles.category}>contact</div>
                        <div className={styles.info}>
                            <p>165 Avenue de Bretagne</p>
                            <p>59000 Lille</p>
                            <p>France</p>
                            <p>contact@edutio.fr</p>
                        </div>
                    </div>
                    <div className={styles.col}>
                        <div className={styles.category}>newsletter</div>
                        <div className={styles.info}>
                            S'inscrire à la newsletter pour recevoir des
                            nouvelles sur l'actualité du secteur.
                        </div>
                        <Subscription
                            className={styles.subscription}
                            placeholder="S'inscrire à la newsletter"
                        />
                    </div>
                </div>
            </div>
            <div className={styles.foot}>
                <div className={cn("container", styles.container)}>
                    <div className={styles.copyright}>
                        Copyright © 2025 Edutio. Tous droits réservés
                    </div>
                    <div className={styles.socials}>
                        {socials.map((x, index) => (
                            <a
                                className={styles.social}
                                href={x.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={index}
                            >
                                <Icon name={x.title} size={x.size} />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
